function N(r) {
  return /^\d+(\.\d+)?$/.test(r);
}
function e(r) {
  return Number.isNaN ? Number.isNaN(r) : r !== r;
}
export { e as isNaN, N as isNumeric };
